import { TabPanel } from '@smartsheet/lodestar-core';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { workflowDataSelector } from '../../../../../../services/ducks/workflowDuck/workflowDuck';
import { DisplayParentWorkflows } from './DisplayParentWorkflows';
import { NoWorkflows } from './NoWorkflows';

export const ParentWorkflow = () => {
  const workflowData = useSelector(workflowDataSelector);
  const parentWorkflowList = useMemo(() => {
    const parentWorkflowsTemp: string[] = [];
    workflowData?.objectReferences?.forEach(reference => {
      if (
        reference.subjectType === 'workflow' &&
        reference.referenceData.triggerdetails.intent
      )
        parentWorkflowsTemp.push(reference.referenceData.triggerdetails.intent);
    });
    return parentWorkflowsTemp;
  }, [workflowData]);
  return (
    <TabPanel>
      {parentWorkflowList.length ? (
        <DisplayParentWorkflows parentWorkflows={parentWorkflowList} />
      ) : (
        <NoWorkflows />
      )}
    </TabPanel>
  );
};
